/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React from 'react';
import styles from './RangeSlider.module.css';
export default function RangeSlider({
    label,
    value,
    min = 0,
    max = 100,
    step = 1,
    onChange,
    suffix = '',
    className = '',
    layout = 'vertical',
    onValueClick,
    onValueMouseEnter,
    onValueMouseLeave,
    valueDisplay,
    onStart,
    onEnd
}) {
    const isHorizontal = layout === 'horizontal';
    const displayVal = valueDisplay !== undefined ? valueDisplay : (value !== undefined ? `${value}${suffix}` : null);
    const isClickable = !!onValueClick;
    const renderValue = () => {
        if (displayVal === null) return null;
        return (
            <span
                className={`${styles.value} ${isClickable ? styles.clickable : ''}`}
                onClick={onValueClick}
                onMouseEnter={onValueMouseEnter}
                onMouseLeave={onValueMouseLeave}
            >
                {displayVal}
            </span>
        );
    };
    return (
        <div className={`${styles.wrapper} ${isHorizontal ? styles.horizontal : ''} ${className}`}>
            {isHorizontal ? (
                <>
                    {label && <label className={styles.label}>{label}</label>}
                    <input
                        type="range"
                        className={styles.range}
                        min={min}
                        max={max}
                        step={step}
                        value={value}
                        onChange={(e) => onChange?.(Number(e.target.value))}
                        onPointerDown={() => onStart?.()}
                        onPointerUp={() => onEnd?.()}
                        onPointerCancel={() => onEnd?.()}
                    />
                    {renderValue()}
                </>
            ) : (
                <>
                    {(label || displayVal !== null) && (
                        <div className={styles.header}>
                            {label && <label className={styles.label}>{label}</label>}
                            {renderValue()}
                        </div>
                    )}
                    <input
                        type="range"
                        className={styles.range}
                        min={min}
                        max={max}
                        step={step}
                        value={value}
                        onChange={(e) => onChange?.(Number(e.target.value))}
                        onPointerDown={() => onStart?.()}
                        onPointerUp={() => onEnd?.()}
                        onPointerCancel={() => onEnd?.()}
                    />
                </>
            )}
        </div>
    );
}
